/**
 * Handles back to top button
 * @module toggleReveal
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'toggleReveal';
export const DEFAULTS = {

};

const makeDisableFocus = (toggleContainer, toggleButton) => () => {
  toggleContainer.find('a').not(toggleButton).attr('tabindex',-1);
}

const makeEnableFocus = (toggleContainer, toggleButton) => () => {
  const anchors = toggleContainer.find('a');
  anchors.not(toggleButton).attr('tabindex', 0);
}

const updateButtonCopy = (toggleButton) => {
  const currentText = toggleButton.find('.action-button__copy').text();
  const newToggleText = toggleButton.data('close-copy');
  toggleButton.data('close-copy', currentText).find('.action-button__copy').text(newToggleText);
}

const makeHandleReveal = (toggleButton, toggleContainer, disableFocus, enableFocus) => () => {
  toggleContainer.toggleClass('active');
  const redirectUrl = toggleButton.data('url');

  if(!redirectUrl || toggleContainer.hasClass('active')) {
    updateButtonCopy(toggleButton);
  }

  if (!toggleContainer.hasClass('active')) {
    if(redirectUrl) {
      toggleButton.attr('href', redirectUrl);
    }
    disableFocus();
  } else {
    enableFocus();
  }

  const refID = toggleButton.attr('id');
  if (refID == 'you-may-like-collapse') {
      toggleButton.attr('id', 'you-may-like-expand');
      $('html, body').animate({
          scrollTop: toggleButton.data('position')
      }, 1000);
      return false;
  } else {
      const positionSet = $(window).scrollTop();
      toggleButton.attr('data-position', positionSet);
      toggleButton.attr('id', 'you-may-like-collapse');
  }
}

export default function toggleReveal($el) {
  const toggleButton = $('.js-toggle-reveal');
  const toggleContainer = $('.js-toggle-reveal-trigger');
  const disableFocus = makeDisableFocus(toggleContainer, toggleButton);
  const enableFocus = makeEnableFocus(toggleContainer, toggleButton);
  const handleReveal = makeHandleReveal(toggleButton, toggleContainer, disableFocus, enableFocus);

  disableFocus();
  toggleButton.on('keyup', (e) => {
    if (e.which === 13 || e.which === 32) {
      if (e.which === 32) {
        e.preventDefault();
        toggleButton.trigger('click');
      }
      if (toggleContainer.hasClass('active')) {
        toggleContainer.find('a').first().focus();
      }
    }
  });
  toggleButton.on('click', handleReveal);
}

registerJQueryPlugin(PLUGIN_NAME, toggleReveal);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/toggle-reveal.js